import store from '@/store'

// 首页 group
const guide = () => import(/* webpackChunkName: "index" */  '@/components/guide.vue')
const index = () => import(/* webpackChunkName: "index" */  '@/components/index.vue')
const menuNav = () => import(/* webpackChunkName: "index" */  '@/components/menuNav.vue')
const shareReg = () => import(/* webpackChunkName: "index" */  '@/components/shareReg.vue')

// user group
const login = () => import(/* webpackChunkName: "user" */  '@/components/user/login.vue')
const reg = () => import(/* webpackChunkName: "user" */  '@/components/user/reg.vue')
const quickReg = () => import(/* webpackChunkName: "user" */  '@/components/user/quickReg.vue')
const protocol = () => import(/* webpackChunkName: "user" */  '@/components/user/protocol.vue')

//搜索小区
const searchHa = () => import(/* webpackChunkName: "ha" */  '@/components/ha/searchHa.vue')
//兑换优惠券
const redeemCoupon = () => import(/* webpackChunkName: "ha" */  '@/components/ha/redeemCoupon.vue')

//我的优惠券
const myCoupon = () => import(/* webpackChunkName: "coupon" */  '@/components/coupon/myCoupon.vue')
const myServiceHa = () => import(/* webpackChunkName: "coupon" */  '@/components/coupon/myServiceHa.vue')

//我的资料
const myInfo = () => import(/* webpackChunkName: "person" */  '@/components/person/myInfo.vue')
const comInfo = () => import(/* webpackChunkName: "person" */  '@/components/person/comInfo.vue')
const follow = () => import(/* webpackChunkName: "person" */  '@/components/person/follow.vue')
const accountBinding = () => import(/* webpackChunkName: "person" */  '@/components/person/accountBinding.vue')
const wxBindBox = () => import(/* webpackChunkName: "person" */  '@/components/person/wxBindBox.vue')

// analysis group
const analysis = () => import(/* webpackChunkName: "analysis" */   '@/components/analysis/index')

// release group
const houseManage = () => import(/* webpackChunkName: "release" */  '@/components/manage/houseManage.vue')
const release = () => import(/* webpackChunkName: "release" */   '@/components/release/index')
const releaseImage = () => import(/* webpackChunkName: "release" */ '@/components/release/image');
const reissue = () => import(/* webpackChunkName: "release" */   '@/components/release/reissue')
const editRelease = () => import(/* webpackChunkName: "release" */   '@/components/release/edit')

//节庆活动
const newYear2020 = () => import(/* webpackChunkName: "activity" */  '@/components/activity/newYear.vue')

//poster group
const posterIndex = () => import(/* webpackChunkName: "poster" */  '@/components/poster/index.vue')
const posterEdit = () => import(/* webpackChunkName: "poster" */  '@/components/poster/edit.vue')
const posterManage = () => import(/* webpackChunkName: "poster" */  '@/components/poster/manage.vue')

//信息核验
const infoVerification = () => import(/* webpackChunkName: "common" */  '@/components/common/infoVerification.vue')

// 公众号运营
const wechatAccount = () => import(/* webpackChunkName: "wechat"*/  '@/components/wechat/wechatAccount.vue')
const selfMenu = () => import(/* webpackChunkName: "wechat"*/  '@/components/wechat/selfMenu.vue')
const materialList = () => import(/* webpackChunkName: "wechat"*/  '@/components/wechat/materialList.vue')
const messaging = () => import(/* webpackChunkName: "wechat"*/  '@/components/wechat/messaging.vue')
const messageShow = () => import(/* webpackChunkName: "wechat"*/  '@/components/wechat/messageShow.vue')

// 物业缴费
const arrearsList = () => import(/* webpackChunkName: "property"*/  '@/components/propertyfee/arrearsList.vue')
const houseList = () => import(/* webpackChunkName: "property"*/  '@/components/propertyfee/houseList.vue')
const orderList = () => import(/* webpackChunkName: "property"*/  '@/components/propertyfee/orderList.vue')
const propertyHa = () => import(/* webpackChunkName: "property"*/  '@/components/propertyfee/propertyHa.vue')
const openWyfee = () => import(/* webpackChunkName: "property"*/  '@/components/propertyfee/openWyfee.vue')
const openWyfee1 = () => import(/* webpackChunkName: "property"*/  '@/components/propertyfee/openWyfee1.vue')
const openWyfee2 = () => import(/* webpackChunkName: "property"*/  '@/components/propertyfee/openWyfee2.vue')
const openWyfee3 = () => import(/* webpackChunkName: "property"*/  '@/components/propertyfee/openWyfee3.vue')
//物业报修
const repairList = () => import(/* webpackChunkName: "property"*/  '@/components/propertyfee/repairList.vue')

// 员工相关
const staffList = () => import(/* webpackChunkName: "staff"*/  '@/components/staff/list.vue')

//房源详细和小区周边
const addHaInfo = () => import(/* webpackChunkName: "trade" */  '@/components/ha/addHaInfo')
const addHaInfoBase = () => import(/* webpackChunkName: "trade" */  '@/components/ha/addHaInfoBase')
const systemName='物业房产服务系统';
const router = new VueRouter({
    mode: 'history',
    //mode: 'hash',
    routes: [
        {
            path: '/index',
            name: 'index',
            component: index,
            meta: {
                title: systemName
            }
        }, {
            path: '/menuNav',
            name: 'menuNav',
            component: menuNav,
            meta: {
                title: '导航'
            }
        }, {
            path: '/guide',
            name: 'guide',
            component: guide,
            meta: {
                title: '社区中介优惠券大放送'
            }
        }, {
            path: '/shareReg',
            name: 'shareReg',
            component: shareReg,
            meta: {
                title: '社区中介优惠券大放送'
            }
        }, {
            path: '/protocol/:protocolType',
            name: 'protocol',
            component: protocol,
            meta: {
                title: '用户协议页面'
            }
        }, {
            path: '/',
            name: 'login',
            component: login,
            meta: {
                title: '登录页面-'+systemName
            }
        },{
            path: '/login',
            redirect: '/',
            name: 'login',
            component: login,
            meta: {
                title: '登录页面-'+systemName
            }
        }, {
            path: '/quickReg',
            name: 'quickReg',
            component: quickReg,
            meta: {
                title: '社区中介优惠券大放送'
            },
        }, {
            path: '/register',
            name: 'register',
            component: reg,
            meta: {
                title: '注册页面'
            },
        }, {
            // 认领小区
            path: '/searchHa',
            name: 'searchHa',
            component: searchHa,
            meta: {
                title: '认领小区-'+systemName,
                menutag:'6-1'
            },
        }, {
            // 兑换优惠券
            path: '/redeemCoupon',
            name: 'redeemCoupon',
            component: redeemCoupon,
            meta: {
                title: '兑换优惠券'
            },
        }, {
            // 我的优惠券
            path: '/myCoupon',
            name: 'myCoupon',
            component: myCoupon,
            meta: {
                title: '我的优惠券'
            },
        }, {
            // 我的社区
            path: '/myServiceHa',
            name: 'myServiceHa',
            component: myServiceHa,
            meta: {
                title: '我的小区-'+systemName,
                menutag:'2-1'
            },
        },
        {
            // 房源分析
            path: '/house/analysis/:saleOrLease',
            name: 'analysis',
            component: analysis,
            meta: {
              title: '房源分析-'+systemName,
                menutag:'2-2'
            },
        },
        {
            // 宣传海报
            path: '/poster/index',
            name: 'posterIndex',
            component: posterIndex,
            meta: {
              title: '宣传海报-'+systemName,
                menutag:'2-3'
            },
        },
        {
            // 编辑海报
            path: '/poster/edit/:posterCode',
            name: 'posterEdit',
            component: posterEdit,
            meta: {
              title: '编辑海报-'+systemName,
                menutag:'2-3'
            },
        },
        {
            // 我的海报
            path: '/poster/manage',
            name: 'posterManage',
            component: posterManage,
            meta: {
              title: '我的海报-'+systemName,
              menutag:'2-3'
            },
        },
        {
            // 发布房源
            path: '/house/release/:saleOrLease',
            name: 'release',
            component: release,
            meta: {
              title: '房源发布-'+systemName,
              menutag:'3-2'
            }
        }, {
            // 房源图片管理
            path: '/house/release/image/:saleOrLease/:dealCode',
            name: 'releaseImage',
            component: releaseImage,
            meta: {
              title: '图片管理',
              menutag:'3-2'
            }
        }, {
            // 重新发布房源
            path: '/house/reissue/:dealCode/:saleOrLease',
            name: 'reissue',
            component: reissue,
            meta: {
              title: '重新发布房源-'+systemName,
              menutag:'3-2'
            }
        }, {
            // 编辑房源
            path: '/house/editRelease/:dealCode/:saleOrLease',
            name: 'editRelease',
            component: editRelease,
            meta: {
              title: '编辑房源-'+systemName,
                menutag:'3-2'
            }
        }, {
            // 房源管理
            path: '/manage',
            name: 'houseManage',
            component: houseManage,
            meta: {
                title: '房源管理-'+systemName,
                menutag:'3-1'
            }
        }, {
            // 信息核验
            path: '/infoVer',
            name: 'infoVerification',
            component: infoVerification,
            meta: {
                title: '信息核验'
            },
        },
        {   // 补充信息
            path: '/ha/addhainfo/:city/:hacode',
            name: 'addHaInfo',
            component: addHaInfo,
            meta: {
                title: '补充小区信息-'+systemName
            },
        },
        {   // 补充小区基本信息
            path: '/ha/addhainfobase/:city/:hacode',
            name: 'addHaInfoBase',
            component: addHaInfoBase,
            meta: {
                title: '补充小区基本信息-'+systemName
            },
        },
        {
            // 员工列表
            path: '/staff',
            name: 'staffList',
            component: staffList,
            meta: {
                title: '员工列表-'+systemName,
                menutag:'4-4'
            },
        },
        {
            // 我的资料
            path: '/myInfo',
            name: 'myInfo',
            component: myInfo,
            meta: {
                title: '个人基本资料-'+systemName
            },
        },{
            // 账户绑定
            path: '/accountBinding',
            name: 'accountBinding',
            component: accountBinding,
            meta: {
                title: '账户绑定-'+systemName
            },
        },
        {
            // 用户身份转换
            path: '/comInfo',
            name: 'comInfo',
            component: comInfo,
            meta: {
                title: '公司基本信息-'+systemName,
                menutag:'4-1'
            },
        },
        {
            //关注
            path: '/follow',
            name: 'follow',
            component: follow,
            meta: {
                title: '关注我们-'+systemName
            },
        },
        {
            //公众号管理
            path: '/wechatAccount',
            name: 'wechatAccount',
            component: wechatAccount,
            meta: {
                title: '公众号管理-'+systemName
            },
        },
        {
            //素材库
            path: '/materialList',
            name: 'materialList',
            component: materialList,
            meta: {
                title: '素材库-'+systemName
            },
        },
        {
            //公众号运营
            path: '/selfMenu',
            name: 'selfMenu',
            component: selfMenu,
            meta: {
                title: '自定义菜单-'+systemName
            },
        },
        {
            //公众号消息群发
            path: '/messaging',
            name: 'messaging',
            component: messaging,
            meta: {
                title: '消息群发-'+systemName
            },
        },
        {
            //物业缴费-开通缴费
            path: '/propertyfee/openWyfee',
            name: 'openWyfee',
            component: openWyfee,
            meta: {
                title: '物业缴费-房屋信息管理-'+systemName
            },
        },
        {
            //物业缴费-开通缴费
            path: '/propertyfee/openWyfee1',
            name: 'openWyfee1',
            component: openWyfee1,
            meta: {
                title: '物业缴费-房屋信息管理-'+systemName
            },
        },
        {
            //物业缴费-开通缴费
            path: '/propertyfee/openWyfee2',
            name: 'openWyfee2',
            component: openWyfee2,
            meta: {
                title: '物业缴费-房屋信息管理-'+systemName
            },
        },
        {
            //物业缴费-开通缴费
            path: '/propertyfee/openWyfee3',
            name: 'openWyfee3',
            component: openWyfee3,
            meta: {
                title: '物业缴费-房屋信息管理-'+systemName
            },
        },
        {
            //物业缴费-房产管理列表
            path: '/propertyfee/houseList',
            name: 'houseList',
            component: houseList,
            meta: {
                title: '物业缴费-房屋信息管理-'+systemName
            },
        },
        {
            //物业缴费-缴费明细
            path: '/propertyfee/orderList',
            name: 'orderList',
            component: orderList,
            meta: {
                title: '物业缴费-缴费明细-'+systemName
            },
        },
        {
            //物业缴费-欠费列表
            path: '/propertyfee/arrearsList',
            name: 'arrearsList',
            component: arrearsList,
            meta: {
                title: '物业缴费-欠费列表-'+systemName
            },
        },
        {
            //物业报修列表
            path: '/propertyfee/repairList',
            name: 'repairList',
            component: repairList,
            meta: {
                title: '物业报修列表-'+systemName
            },
        },
        {
            //公众号消息详细
            path: '/messageshow',
            name: 'messageShow',
            component: messageShow,
            meta: {
                title: '消息详细-'+systemName
            },
        },
        {
            // 2020年元旦活动
            path: '/newYear',
            name: 'newYear',
            component: newYear2020,
            meta: {
                title: '城市房产中介服务新年大礼'
            },
        }
    ]
});

// 不同页面title展示，兼容处理ios微信
document.setTitle = function (t) {
    document.title = t;
}

router.beforeEach((to, from, next) => {
    //已登录关闭浏览器，再次打开更新权限
    if(window.sessionStorage.getItem("areadyUpdateUserMenu")!=1){
        store.dispatch("updateUserMenu").then(()=>{
            goNext();
        })
    }else{
        goNext();
    }
    function goNext(){
        //权限限制
        if(to.meta.menutag&&!store.getters.isAdmin&&!store.getters.userMenu.includes(to.meta.menutag)){
            Vue.prototype.$toast("您暂无权限访问，请联系管理员");return;
        }
        // 百度统计PV
        if (to.path) {
            store.getters.statistics(to.path);
        }
        // 记录当前菜单信息
        store.dispatch('setActiveMenu', to.name);

        // fixed: ios分享详情页，分享出去的却是入口页问题
        const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isiOS && to.path != location.pathname) {
            window.location.assign(to.fullPath);
        }
        next()
    }

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js